import React from "react";
import { InputAdornment, OutlinedInput, OutlinedInputProps } from "@mui/material";

interface CurrencyInputProps extends Omit<OutlinedInputProps, 'onChange' | 'value' | 'type'> {
    value: number | null | undefined;
    onChange: (value: number) => void;
}

// Digita-se em centavos, da direita pra esquerda (igual maquininha de cartão),
// pra ficar impossível confundir 1.000 com 1.000.000 por causa de zeros a mais/a menos.
const formatFromCents = (cents: number): string => {
    return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
    ({ value, onChange, ...rest }, ref) => {
        const cents = Math.round((value ?? 0) * 100);
        const displayValue = !value ? '' : formatFromCents(cents);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const digitsOnly = e.target.value.replace(/\D/g, '');
            const newCents = digitsOnly === '' ? 0 : parseInt(digitsOnly, 10);
            onChange(newCents / 100);
        };

        return (
            <OutlinedInput
                ref={ref}
                value={displayValue}
                onChange={handleChange}
                startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                inputProps={{ inputMode: 'numeric' }}
                {...rest}
            />
        );
    }
);

CurrencyInput.displayName = 'CurrencyInput';

export default CurrencyInput;
